import React from 'react'

function PlusThinIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 3.75V16.25M16.25 10L3.75 10"
        stroke="#FAFAFA"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

PlusThinIcon.defaultProps = {
  className: '',
}
export default PlusThinIcon
